import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getLocationWidgetFieldSettingsConfig,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  defaultLocationWidgetFieldConfigFormModel,
  locationWidgetFieldParseIntoSettingsFormModel,
  locationWidgetFieldUpdateFromSettingsFormModel,
} from '../location-widget-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomCascadingDropdownsFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: any, field: any) {
    super(injector, field);

    this.settingsFormlyModel = defaultLocationWidgetFieldConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getLocationWidgetFieldSettingsConfig(this.formBuilderService),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return locationWidgetFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return locationWidgetFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
